import {Stack, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	background-color: ${({theme}) => theme.palette.primary.main};
	padding: 8px 16px 16px;
`;
